/*global _, addiesaas, $, debugLog */
import {Vue} from '~/addiesaas'
import createPersistedState from 'vuex-persistedstate'
import * as types from '../mutation-types/import'
const namespaced = true
export const namespace = 'Import'

const EventBus = window.VueEventBus

const defaults = {
  job: {},
  preview: {},
  nav: {
    step: 0,
    steps: [
      'init',
      'encoding',
      'processing',
      'mapping',
      'end',
    ],
    stepComponents: [
      'dropzone',
      'encoder',
      'processor',
      'fields',
      'status',
    ],
    canSkipEncodingStep: null,

    stepIsValid: false,

    finalizingValidationData: {},
    finalizingValidationErrors: {},
    finalizingValidationFailed: false,

    validStepList: [
      false,
      false,
      false,
      false,
      false,
    ],
    noClick: (e) => {
      e.stopPropagation && e.stopPropagation()
    },
    noHeader: false,
  },
  uploader: {
    fileDropZone: null,
    isUploading: false,
    uploadedFileName: '',
    uploadProgressAmount: null,
    uploadCompleted: false,
    showUploadedMessage: false,
  },
  processor: {
    internalImportId: _.uniqueId('import-'),
    selectedEncoding: 'Auto Detect',
    importMode: 'add',
    skipEmptyValues: true,
    uniqueFields: '',
    finalizeFields: {},
    isValidating: false,
    isFinalizing: false,

    isProcessing: false,
    processingMessage: '',

    mappingValue: {},
    processorConfig: {},
    finalizedData: {}
  }
}
// state
const state = {
  getterForMixin: ['getStoreValue', 'nav', 'conf', 'processor', 'uploader'],

  computers: ['job', 'preview', 'jobConfig', 'jobSetting', 'encodingTypes'],
  job: _.cloneDeep(defaults.job),
  preview: _.cloneDeep(defaults.preview),
  jobConfig: {},
  jobSetting: {},
  encodingTypes: {},

  deepComputers: ['conf', 'nav', 'uploader', 'processor'],
  conf: {
    sampleUrl: '',
    serviceHeaders: {},
    jobSettingId: null,
    jobSettingHashedId: null,
    showHeader: false,
    entityName: '',
    entityname: '',
    entityNamePlural: '',
    entitynameplural: '',
    importFinalizeStarted: null,
    importFinalized: null,
    backUrl: ''
  },
  nav: _.cloneDeep(defaults.nav),
  uploader: _.cloneDeep(defaults.uploader),
  processor: _.cloneDeep(defaults.processor)
}

// mutations
const mutations = {
  [types.RESET_EVERYTHING](state) {
    _.forOwn(defaults, (item, key) => {
      Vue.set(state, key, _.cloneDeep(item))
    })
  },
  [types.SET_STORE_CONFIG](state, item) {
    const storage = item.accessor ? state[item.accessor] : state
    Vue.set(storage, item.key, item.value)
  },
  [types.SET_JOB](state, item) {
    state.job = item
  },
  [types.SET_JOB_CONFIG](state, item) {
    state.jobConfig = item
  },
  [types.UPDATE_JOB_CONFIG](state, item) {
    state.jobConfig = _.merge({}, state.jobConfig, item)
  },
  [types.SET_JOB_SETTING](state, item) {
    state.jobSetting = item
  },
  [types.STEP_UP_DOWN](state, direction) {
    const nav = state.nav
    const prevStep = nav.step
    const possibleStep = nav.step + direction
    if (nav.steps[possibleStep]) {
      Vue.set(nav, 'step', possibleStep)
      EventBus.$emit('import.nav', possibleStep, prevStep)
      EventBus.$emit('import.nav.' + (direction < 1 ? 'prev' : 'next'), possibleStep, prevStep)
    }
  },
}

// actions
const actions = {
  setStoreValue({commit}, payload) {
    commit(types.SET_STORE_CONFIG, payload)
  },
  setJob({commit}, payload) {
    commit(types.SET_JOB, payload)
    EventBus.$emit('import.job.loaded', payload)
  },
  setJobConfig({commit}, payload) {
    commit(types.SET_JOB_CONFIG, payload)
    EventBus.$emit('import.job.config.loaded', payload)
  },
  setJobSetting({commit}, payload) {
    commit(types.SET_JOB_SETTING, payload)
    EventBus.$emit('import.job.setting.loaded', payload)
  },

  updateJobConfig({commit}, payload) {
    commit(types.UPDATE_JOB_CONFIG, payload)
    EventBus.$emit('import.job.config.updated', payload)
  },
  goPrevStep({commit, getters}, step) {
    commit(types.STEP_UP_DOWN, -step)
  },
  goNextStep({commit, getters}, step) {
    commit(types.STEP_UP_DOWN, step)
  },
  resetEverything({commit, getters}) {
    commit(types.RESET_EVERYTHING)
  }
}

// getters
const getters = {
  job: state => state.job,
  jobConfig: state => state.jobConfig,
  jobSetting: state => state.jobSetting,
  nav: state => state.nav,
  conf: state => state.conf,
  uploader: state => state.uploader,
  processor: state => state.processor,
  getStoreValue(state) {
    return function (accessor, key) {
      const storage = accessor ? state[accessor] : state
      return _.get(storage, key)
    }
  },
}

// plugins
const plugins = [
  // createPersistedState({
  //   key: 'utils-import',
  // })
]

const cart = {namespaced, namespace, state, mutations, actions, getters, plugins}
export default cart
